<template>
  <div v-show="show"
       :class="'notification ' + alertClass">{{ notification }}</div>
</template>

<style>
.notification {
  display: inline-block;
}
.notification.error {
  color: #e74c3c;
}
</style>

<script>
export default {
  name: 'AutoHideNotification',
  props: ['type', 'message'],
  data () {
    return {
      show: false,
      notification: this.message,
      alertClass: this.type,
      hideTimeout: false
    }
  },
  methods: {
    displayNotification (message, type) {
      this.notification = message
      this.alertClass = type
      this.showNotification()
    },
    showNotification () {
      this.show = true
      this.hideNotification()
    },
    hideNotification () {
      this.hideTimeout = setTimeout(() => {
        this.show = false
      }, 10000)
    },
    destroyNotification () {
      this.show = false
      clearTimeout(this.hideTimeout)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/AutoHideNotification.vue